// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__bODmk","secondary":"styles_secondary__RBASs"};